import { UserRole } from '@baseball-near-you/common';
import { PersonalUserHandednessForm } from '@bb/components/PersonalUserForms/PersonalUserHandednessForm';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';
import posthog from 'posthog-js';
import { useEffect } from 'react';

export function HandednessStep(props: {
  onStepSuccess: () => Promise<void>;
}) {
  const { userProfile } = useUserProfile();

  useEffect(() => {
    posthog.capture('handedness_step_viewed', {
      user_id: userProfile?.id,
    });
  }, [userProfile?.id, posthog]);

  return (
    <div>
      <div className="flex flex-col">
        <p className="font-medium text-lg">
          {userProfile?.role === UserRole.Parent
            ? 'How does your athlete play?'
            : 'How do you play?'}
        </p>
        <p className="text-gray-500 text-sm">
          Indicate the hand{' '}
          {userProfile?.role === UserRole.Parent
            ? 'your athlete primarily uses'
            : 'you primarily use'}{' '}
          to throw and hit a baseball with.
        </p>
      </div>
      <PersonalUserHandednessForm
        onSuccess={props.onStepSuccess}
        submitButtonLabel="Continue"
      />
    </div>
  );
}
